/* StadiumBlok — locale link fixer.
   Shopify auto-localizes menu (linklist) URLs but NOT raw URL settings typed into
   theme sections (image cards, rich-text buttons, etc.). On a non-default locale
   those hardcoded internal links drop the locale prefix and revert the visitor to
   the default language. This rewrites any internal <a href="/..."> that is missing
   the active locale prefix so navigation stays in the chosen language. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root === '/') return;                 // default locale: nothing to fix
  var base = root.replace(/\/$/, '');        // "/it"

  function localize() {
    var as = document.querySelectorAll('a[href^="/"]');
    for (var i = 0; i < as.length; i++) {
      var href = as[i].getAttribute('href');
      if (!href) continue;
      if (href.charAt(1) === '/') continue;                       // protocol-relative //cdn...
      if (href === base || href.indexOf(base + '/') === 0) continue; // already localized
      as[i].setAttribute('href', base + href);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', localize);
  } else {
    localize();
  }
})();
